import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class SwipeclockService {
  constructor(
    private httpClient: HttpClient,
    @Inject('env') private env: any,
    @Inject('errorInterceptorSkipHeader') private errorInterceptorSkipHeader: any,
    private authService: AuthService
  ) {}

  public getPortalJwt(authType: string, clientCode: string, userId: string) {
    const headers = new HttpHeaders().set(this.errorInterceptorSkipHeader, '');
    const uri = `${this.env.apiUrlRoot}/Swipeclock/GetPortalJwt`;
    let params = new HttpParams();

    params = params.set('authType', authType.trim());
    params = params.set('clientCode', clientCode.trim());
    params = params.set('userId', userId.trim());

    return this.httpClient.get<{ success: boolean; jwt: string }>(uri, { params, headers });
  }

  // FIXME - Add wrapper for OpenPortal
}
